var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-google-translate',{attrs:{"defaultLanguageCode":_vm.$store.state.user.options.locale,"defaultPageLanguageCode":"ru","fetchBrowserLanguage":false,"languages":_vm.languages},on:{"select":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }